import React from "react";
import { useFormikContext } from "formik";

export function HeaderCheckbox({ marginTop = "28px", marginBottom = "10px", ...props }) {
  const { label, field } = props;
  const { setFieldValue } = useFormikContext();
  return (
    <>
      <div style={{
        marginTop: marginTop,
        marginBottom: marginBottom
      }}>
        <input type="checkbox" style={{ display: "none" }} />
        <label className="checkbox checkbox-single">
          <input
            type="checkbox"
            checked={field.value}
            onChange={(e) => {
              setFieldValue(field.name, e.target.checked);
            }}
          />
          <span className="mr-4" />
          {label}
        </label>
      </div>
    </>
  );
}
